/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Vocabulary a company uses for its engagement index. HAPPINESS keeps the historical \"Happiness Index\" wording (default for existing companies); WELLBEING shows the \"Wellbeing Index\" wording. Presentation only — it does not change how the index is computed.
 * @export
 * @enum {string}
 */

export const IndexTerminology = {
    Happiness: 'HAPPINESS',
    Wellbeing: 'WELLBEING'
} as const;

export type IndexTerminology = typeof IndexTerminology[keyof typeof IndexTerminology];



